import {db} from '@/firebase'
import EventEmitter from 'events'
import { store } from '@/store'
import moment from 'moment'

class AppointmentRepository extends EventEmitter {
    constructor () {
        super()

        this.collection = db.collection('appointments')

        return this
    }

    find (id, onSuccess, onError) {
        this.collection
            .doc(id)
            .get()
            .then((doc) => {
                if (doc.exists) {
                    onSuccess(doc.data())
                } else {
                    onError({message: "Appointment was not found"})
                }
            })
            .catch(onError)
    }

    allForOfficeDate(doctorId, officeId, date, onSuccess, onError) {
        this.collection
            .where('doctorId', '==', doctorId)
            .where('officeId', '==', officeId)
            .where('date', '==', date)
            .get()
            .then((querySnapshot) => {
                let appointments = {}

                querySnapshot.forEach((doc) => {
                    appointments[doc.id] = doc.data()
                });

                onSuccess(appointments)
            })
            .catch(onError)
    }

    allForPatient (patientId, onSuccess, onError) {
        let currentTime = Math.floor((moment().hour() * 60 + moment().minute()) / 15)

        this.collection
            .where('patientId', '==', patientId)
            .where('date', '>=', moment().format('YYYY-MM-DD'))
            .get()
            .then((querySnapshot) => {
                let appointments = {}

                querySnapshot.forEach((doc) => {
                    let appointment = doc.data()

                    // Only get appointments for other days or later this day
                    appointments[doc.id] = appointment
                    // if (appointment.time >= currentTime) {
                    // }
                });

                onSuccess(appointments)
            })
            .catch(onError)
    }
}

export default new AppointmentRepository()


// WEBPACK FOOTER //
// ./src/data/AppointmentRepository.js